module.exports = __webpack_public_path__ + "static/Pt31-removebg-preview-5d522cba2aeb0aabd9da39bb7201dfe3.png";